var _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8AnonymousMask480(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ffff",
    d: "M22,4v3v37.107C23.22,44.723,24,45,24,45s17-6,17-25V4H22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7debf5",
    d: "M24,7v38c0,0-17-6-17-25V7H24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M26,7h-4v37.107C23.22,44.723,24,45,24,45s0.78-0.277,2-0.893V7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M11,14c0.857-0.499,3.904-1.733,7.418-0.483c2.969,1.056,3.787,3.576,3.542,4.483L11,14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M37,14c-0.857-0.499-3.904-1.733-7.418-0.483c-2.969,1.056-3.787,3.576-3.542,4.483L37,14z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c19ff",
    points: "22,37 26,37 24,45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M16,19c2.209,0,4,1.343,4,3h-8C12,20.343,13.791,19,16,19z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M32,19c2.209,0,4,1.343,4,3h-8C28,20.343,29.791,19,32,19z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c19ff",
    points: "33,34 26,34 24,32 22,34 15,34 12,31 14,29 16,31 21,31 24,28 27,31 32,31 34,29 36,31"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AnonymousMask480);
export default __webpack_public_path__ + "static/media/icons8-anonymous-mask-480.335fd39ce6ce826d15ae5cd470b3d5c7.svg";
export { ForwardRef as ReactComponent };